import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Login: React.FC = () => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <>
            <div className="col-12 col-md-8 col-xl-6">
                <div className="h-100 py-4 px-md-3">
                    <div className="row h-100 align-items-center justify-content-center">
                        <div className="col-12 col-sm-8 col-md-11 col-xl-11 col-xxl-10 login-box">
                            <div className="card mb-3">
                                <div className="card-body">
                                    <div className="text-center mb-4">
                                        <h2 className="mb-1 text-theme-1">Login</h2>
                                        <p className="text-secondary">Take a deep dive into the new modern era</p>
                                    </div>
                                    <div className="form-floating mb-3">
                                        <input type="email" className="form-control" id="emailadd" placeholder="Enter email address" defaultValue="guest@adminuiux" autoFocus />
                                        <label htmlFor="emailadd">Email Address</label>
                                    </div>
                                    <div className="position-relative">
                                        <div className="form-floating mb-3">
                                            <input type={showPassword ? "text" : "password"} className="form-control" id="passwd" placeholder="Enter your password" defaultValue="1234" />
                                            <label htmlFor="passwd">Password</label>
                                        </div>
                                        <button
                                            className={`btn btn-square btn-link text-theme-1 position-absolute end-0 top-0 mt-2 me-2 ${showPassword ? 'active' : ''}`}
                                            onClick={() => setShowPassword(!showPassword)}
                                            type="button"
                                        >
                                            <i className={`bi bi-eye${showPassword ? '-slash' : ''}`}></i>
                                        </button>
                                    </div>
                                    <div className="row gx-3 align-items-center mb-3">
                                        <div className="col py-2">
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" name="rememberme" id="rememberme" />
                                                <label className="form-check-label" htmlFor="rememberme">Remember me</label>
                                            </div>
                                        </div>
                                        <div className="col-auto">
                                            <Link to="/auth/forgot-password" className="btn btn-link">Forgot Password?</Link>
                                        </div>
                                    </div>
                                    <div className="row gx-3 align-items-center mb-4">
                                        <div className="col">
                                            <Link to="/app/dashboard" className="btn btn-lg btn-theme w-100">Login</Link>
                                        </div>
                                        <div className="col">
                                            <Link to="/auth/signup" className="btn btn-lg btn-link w-100">Signup <i className="bi bi-chevron-right"></i></Link>
                                        </div>
                                    </div>
                                    <div className="row gx-3 align-items-center mb-4">
                                        <div className="col">
                                            <hr />
                                        </div>
                                        <div className="col-auto">
                                            <p className="text-secondary">OR Continue with</p>
                                        </div>
                                        <div className="col">
                                            <hr />
                                        </div>
                                    </div>
                                    <div className="row gx-2 justify-content-center align-items-center">
                                        <div className="col-auto">
                                            <button className="btn btn-link text-start">
                                                <img src={asset('/assets/img/g-logo.png')} alt="" className="me-1 me-md-2" /> Google
                                            </button>
                                        </div>
                                        <div className="col-auto">
                                            <button className="btn btn-link text-start">
                                                <img src={asset('/assets/img/f-logo.png')} alt="" className="me-1 me-md-2" /> Facebook
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Login;
